import Vue              from 'vue'
import Vuex             from 'vuex'
import * as api         from '../api'
const cookie = require('browser-cookies')
const state = {
  userId:cookie.get('userId') || '',
  token:cookie.get('token') || '', 
  seed:cookie.get('seed') || '',
  orgId:cookie.get('orgId') || '',
  username:cookie.get('username') || '',
  headimg:cookie.get('headimg') || ''
  
  // userId:'ffa87943-e594-4914-bc21-42667325c42b',
  // token:'token', 
  // seed:'',
  // orgId:'1',
  // username:cookie.get('username') || '',
  // headimg:cookie.get('headimg') || ''
}

const mutations = {
  SET_TOKEN_DATA:(state,option) => {
       state.token = option.token
       state.userId = option.userId
       state.seed = option.seed
       state.orgId = option.orgId
       state.username = option.username
       state.headimg = option.headimg
       
    },
}

const actions = {




}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/userinfo.js